export default __webpack_public_path__ + "static/media/helmet4.cd1a9951.svg";